import PythonApi from "../services/PythonApi";

export default {
  async list() {
    const url = "thi_sensor";
    return PythonApi().get(url, new URLSearchParams());
  },

  async get(id) {
    const url = `thi_sensor/${id}`;
    return PythonApi().get(url, new URLSearchParams());
  },

  async create(data) {
    const url = "thi_sensor";
    return PythonApi().post(url, data);
  },

  async update(id, data) {
    const url = `thi_sensor/${id}`;
    return PythonApi().put(url, data);
  },

  async chart(id, type, fromDate, toDate) {
    const params = new URLSearchParams();
    params.append("thi_sensor_id", id);
    params.append("type", type);
    if (fromDate)
      params.append("from_date", fromDate);
    if (toDate)
      params.append("to_date", toDate);
    return PythonApi().get("thi_sensor/chart", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/thi-sensor-api.js